import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import socketIOClient from 'socket.io-client';

import { classNames } from 'utils/functions';
import { OPERATION_KINDS } from 'utils/enums';
import GeneralApi from 'utils/generalApi';

import { useAuth } from 'contexts/Auth';

import LandingHeader from 'components/Navigation/LandingHeader';
import { showErrorToast } from 'components/Toast';

import Logo from 'img/logo.png';
import ExchangeLogo from 'img/exchange.logo.png';
import CCLLogo from 'img/ccl.png';
import Image1 from 'img/img_1.png';
import MainBg from 'img/main_bg.big.png';

import { ReactComponent as TransferIcon } from 'img/icons/transfer.svg';
import { ReactComponent as Step1 } from 'img/icons/step_1.svg';
import { ReactComponent as Step2 } from 'img/icons/step_2.svg';
import { ReactComponent as Step3 } from 'img/icons/step_3.svg';
import { ReactComponent as Step4 } from 'img/icons/step_4.svg';

import { ReactComponent as Offer1 } from 'img/icons/offer_1.svg';
import { ReactComponent as Offer2 } from 'img/icons/offer_2.svg';
import { ReactComponent as Offer3 } from 'img/icons/offer_3.svg';
import { APP_NAME, APP_NAME_BRAND } from 'utils/constants';
import LandingFooter from 'components/Navigation/Footer';
import { Link } from "react-router-dom";

export default function LandingPage() {
  const history = useNavigate();
  const auth = useAuth();

  const generalApi = useMemo(() => new GeneralApi(auth, history, 'customer'), [auth, history]);

  const steps = [
    {
      title: 'INICIA SESIÓN O REGÍSTRATE',
      content:
        'Ingresa los datos para conocernos mejor. Seas persona natural o jurídica, te brindaremos herramientas para que sigas tus operaciones',
      image: <Step1 className="mx-auto h-40 w-40 rounded-full" />,
    },
    {
      title: 'REALIZA TU OPERACIÓN',
      content:
        'Ingresa los datos para conocernos mejor. Seas persona natural o jurídica, te brindaremos herramientas para que sigas tus operaciones',
      image: <Step2 className="mx-auto h-40 w-40 rounded-full" />,
    },
    {
      title: 'TRANSFIERE Y COMUNICA',
      content:
        'Ingresa los datos para conocernos mejor. Seas persona natural o jurídica, te brindaremos herramientas para que sigas tus operaciones',
      image: <Step3 className="mx-auto h-40 w-40 rounded-full" />,
    },
    {
      title: 'RECIBE TU DINERO',
      content:
        'Ingresa los datos para conocernos mejor. Seas persona natural o jurídica, te brindaremos herramientas para que sigas tus operaciones',
      image: <Step4 className="mx-auto h-40 w-40 rounded-full" />,
    },
  ];

  // const ENDPOINT = 'https://app-exchange.herokuapp.com/';
  //  const ENDPOINT = 'http://206.189.223.234:1337/';
  // const ENDPOINT = 'https://api.izidolar.com/';
  const ENDPOINT = 'https://api.cambiob2b.com/';

  const [bannerText, setBannerText] = useState('');
  const [aboutText, setAboutText] = useState('');
  const [titleText, setTitleText] = useState('');
  const [subtitleText, setSubtitleText] = useState('');

  const [currentBid, setCurrentBid] = useState(0);
  const [currentOffer, setCurrentOffer] = useState(0);
  const [ranges, setRanges] = useState<
    Array<{
      importe: number;
      BID: number;
      OFFER: number;
    }>
  >([]);

  const [operation, setOperation] = useState(OPERATION_KINDS.SELL);
  const [leftAmount, setLeftAmount] = useState('0');
  const [rightAmount, setRightAmount] = useState('1000');

  const updateOperationType = (newOperation: OPERATION_KINDS) => {
    setOperation(newOperation);
    updateFromLeft(leftAmount, newOperation);
  };

  const updateFromLeft = (value: string, operationType: OPERATION_KINDS) => {
    if (!ranges || !value || !operationType) return;
    const currentRange = ranges.reduce(
      (a, b) => (b.importe < parseFloat(value.replace(/,/g, '')) && b.importe > a.importe ? b : a),
      { importe: 0, BID: currentBid, OFFER: currentOffer }
    );
    setCurrentBid(currentRange.BID);
    setCurrentOffer(currentRange.OFFER);
    if (operationType === OPERATION_KINDS.SELL) {
      setRightAmount((Number(value.replace(/,/g, '')) * currentOffer)?.toFixed(2));
    } else if (operationType === OPERATION_KINDS.BUY) {
      setRightAmount((Number(value.replace(/,/g, '')) * currentBid)?.toFixed(2));
    }
    //numberWithCommas(document.getElementById("inp_amount_2"));
  };

  const updateFromRight = useCallback(
    (
      value: string,
      operationType: OPERATION_KINDS,
      newRanges: Array<{
        importe: number;
        BID: number;
        OFFER: number;
      }>
    ) => {
      if (!newRanges || !value) return;
      const rangeSoles = (amount: number) =>
        operationType === OPERATION_KINDS.SELL
          ? newRanges
              .map((c) => ({
                importe: c.importe * c.BID,
                BID: c.BID,
                OFFER: c.OFFER,
              }))
              .reduce((a, b) => (b.importe < amount && b.importe > a.importe ? b : a), {
                importe: 0,
                BID: currentBid,
                OFFER: currentOffer,
              })
          : newRanges
              .map((c) => ({
                importe: c.importe * c.OFFER,
                BID: c.BID,
                OFFER: c.OFFER,
              }))
              .reduce((a, b) => (b.importe < amount && b.importe > a.importe ? b : a), {
                importe: 0,
                BID: currentBid,
                OFFER: currentOffer,
              });

      const values = rangeSoles(Number(value.replace(/,/g, '')));
      if (currentBid !== values.BID) setCurrentBid(values.BID);
      if (currentOffer !== values.OFFER) setCurrentOffer(values.OFFER);
      if (operationType === OPERATION_KINDS.SELL) {
        setLeftAmount(
          currentOffer > 0 ? (Number(value.replace(/,/g, '')) / currentOffer)?.toFixed(2) : '0'
        );
      } else if (operationType === OPERATION_KINDS.BUY) {
        setLeftAmount((Number(value.replace(/,/g, '')) / currentBid)?.toFixed(2));
      }
      //numberWithCommas(document.getElementById("inp_amount"));
    },
    [currentBid, currentOffer]
  );

  useEffect(() => {
    const getCurrentChange = async () => {
      const result = await generalApi.get(`/current_change`);
      if (!result.success) {
        showErrorToast(result.message);
        return;
      }
      setCurrentBid(result.data.BID);
      setCurrentOffer(result.data.OFFER);
      setRanges(result.data.ranges);
    };
    const getBanner = async () => {
      const result = await generalApi.get(`/webinfo/banner`);
      if (!result.success) {
        showErrorToast(result.message);
        return;
      }
      setBannerText(result.data.info);
    };
    const getAboutUs = async () => {
      const result = await generalApi.get(`/webinfo/about`);
      if (!result.success) {
        showErrorToast(result.message);
        return;
      }
      setAboutText(result.data.info);
    };
    const getTitle = async () => {
      const result = await generalApi.get(`/webinfo/fl1`);
      if (!result.success) {
        showErrorToast(result.message);
        return;
      }
      setTitleText(
        result.data.info ||
          `<p style=font-size:27px;color:rgb(73,180,135);line-height:0.5;><b>¡Bienvenido a EXCHANGE!</b></p>`
      );
    };
    const getSubtitle = async () => {
      const result = await generalApi.get(`/webinfo/fl2`);
      if (!result.success) {
        showErrorToast(result.message);
        return;
      }
      setSubtitleText(
        result.data.info ||
          `<p style=font-size:25px;line-height:0.5;><b>Tu casa de cambios digital,<br>con la seguridad que buscas</b></p>`
      );
    };

    const socket = socketIOClient(ENDPOINT);
    socket.on('new_change', () => {
      getCurrentChange();
    });
    getCurrentChange();
    getBanner();
    getAboutUs();
    getTitle();
    getSubtitle();
  }, [generalApi]);

  useEffect(() => {
    updateFromRight(rightAmount, operation, ranges);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ranges, updateFromRight]);

  return (
    <div className="text-[#1B205A]">
      <div
        className="relative bg-blue-200 bg-cover"
        style={{
          backgroundImage: `url(${MainBg})`,
        }}
      >
        <div className="absolute inset-0 bg-[#1B205A]/60" />
        <LandingHeader />
        <div className="relative pt-36 text-center text-white sm:mt-4 sm:pt-0">
          <h1 dangerouslySetInnerHTML={{ __html: titleText }} />
          <p dangerouslySetInnerHTML={{ __html: subtitleText }} />
          <div className="mx-2 mt-8 max-w-lg rounded-xl bg-white px-4 py-6 text-[#1B205A] shadow-lg shadow-primary-500 sm:mx-auto sm:p-8">
            <div className="flex items-center justify-around">
              <div
                className={classNames(
                  operation === OPERATION_KINDS.BUY ? 'bg-primary-200' : 'hover:bg-primary-100',
                  'cursor-pointer rounded-xl px-4 py-2 transition-all duration-300'
                )}
                onClick={() => updateOperationType(OPERATION_KINDS.BUY)}
              >
                <p className="hidden sm:block">{APP_NAME_BRAND} Compra</p>
                <p className="block sm:hidden">Compra</p>
                <p className="text-xl">S/ {currentBid?.toFixed(4)}</p>
              </div>
              <img
                src={process.env.REACT_APP_LOGO === 'exchange' ? ExchangeLogo : Logo}
                className="h-10 sm:h-14"
                alt=""
              />
              <div
                className={classNames(
                  operation === OPERATION_KINDS.SELL ? 'bg-primary-200' : 'hover:bg-primary-100',
                  'cursor-pointer rounded-xl px-4 py-2 transition-all duration-300'
                )}
                onClick={() => updateOperationType(OPERATION_KINDS.SELL)}
              >
                <p className="hidden sm:block">{APP_NAME_BRAND} Vende</p>
                <p className="block sm:hidden">Vende</p>
                <p className="text-xl">S/ {currentOffer?.toFixed(4)}</p>
              </div>
            </div>
            <div className="mt-4 items-center justify-around sm:flex">
              <div className="-mb-4 flex justify-between space-x-3 rounded-xl border-2 border-primary-600 px-4 py-2 text-lg shadow-md shadow-primary-100 sm:mb-0 sm:w-5/12">
                <div className="font-bold">
                  <p>USD</p>
                  <p>$</p>
                </div>
                <div className="flex-1 text-right">
                  <p className="mt-1 text-sm font-bold">
                    {operation === OPERATION_KINDS.BUY ? 'Tú vendes' : 'Tú compras'}
                  </p>
                  <input
                    className="w-full border-0 pt-1 pb-0 pr-0 text-right text-xl focus:ring-0"
                    type="text"
                    value={leftAmount}
                    onChange={(event) => {
                      setLeftAmount(event.target.value.toString());
                      updateFromLeft(event.target.value.toString(), operation);
                    }}
                  />
                </div>
              </div>
              <div
                className="relative z-10 mx-auto h-12 w-12 cursor-pointer rounded-full bg-blue-900 p-1.5"
                onClick={() =>
                  updateOperationType(
                    operation === OPERATION_KINDS.BUY ? OPERATION_KINDS.SELL : OPERATION_KINDS.BUY
                  )
                }
              >
                <TransferIcon className="h-9 w-9" />
              </div>
              <div className="relative -mt-4 flex justify-between space-x-4 rounded-xl border-2 border-primary-600 px-4 py-2 text-lg shadow-md shadow-primary-100 sm:mt-0 sm:w-5/12">
                <div className="font-bold">
                  <p>PEN</p>
                  <p>S/</p>
                </div>
                <div className="text-right">
                  <p className="mt-1 text-sm font-bold">
                    {operation === OPERATION_KINDS.BUY ? 'Tú recibes' : 'Tú depositas'}
                  </p>
                  <input
                    className="w-full border-0 pt-1 pb-0 pr-0 text-right text-xl focus:ring-0"
                    type="text"
                    value={rightAmount}
                    onChange={(event) => {
                      setRightAmount(event.target.value.toString());
                      updateFromRight(event.target.value.toString(), operation, ranges);
                    }}
                  />
                </div>
              </div>
            </div>
            <button className="mt-6 w-full rounded-lg bg-primary-600 px-12 py-2 text-white transition-colors hover:bg-primary-700">
              Cambiar ahora
            </button>
          </div>
          {bannerText && (
            <div
              className="mt-12 w-full bg-primary-600 px-4 py-6 sm:px-8"
              dangerouslySetInnerHTML={{ __html: bannerText }}
            />
          )}
        </div>
      </div>
      <div className="bg-white py-24 px-16 text-center">
        <p className="xs:text-5xl mb-6 text-4xl font-bold">¿CÓMO FUNCIONA?</p>
        <p className="mx-auto max-w-4xl text-2xl">
          Puedes cambiar dólares de manera sencilla y segura, usando únicamente transferencias
          bancarias, obteniendo el mejor precio
        </p>
        <div className="mt-16 space-y-16 lg:flex lg:space-y-0 lg:space-x-16">
          {steps.map((step, index) => (
            <div key={index}>
              {step.image}
              <p className="mt-6 text-2xl font-bold">{step.title}</p>
              <p className="mt-4 text-lg">{step.content}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-gray-100 px-8 py-12 text-center sm:p-16">
        <p className="xs:text-5xl mb-6 text-4xl font-bold">CONÓCENOS MÁS</p>
        <p className="mx-auto text-2xl">{aboutText}</p>
      </div>
      <div className="sm:flex">
        <div className="bg-[#E4E7EB] pt-8 sm:w-1/2 sm:pt-0">
          <img src={Image1} className="mx-auto max-h-full sm:mt-4" alt="" />
        </div>
        <div className="flex flex-col items-center justify-center bg-blue-900 p-12 text-center text-white sm:w-1/2">
          <p className="mb-12 text-5xl font-bold">{APP_NAME.toUpperCase()} PARA TU EMPRESA</p>
          <p className="mx-auto text-2xl">
            Nuestro equipo de profesionales te brindará soluciones personalizadas para optimizar tus
            finanzas. Regístrate y conoce más de lo que podemos ofrecerte.
          </p>
          <Link
            to="/signup"
            className="mt-16 inline-block rounded-lg bg-primary-600 px-12 py-2 text-white transition-colors hover:bg-primary-700">
            Quiero Registrarme
          </Link>
        </div>
      </div>
      <div className="bg-primary-600 px-8 pt-12 pb-32 text-center text-white sm:px-16 sm:pt-24 sm:pb-40">
        <p className="xs:text-5xl mb-6 text-4xl font-bold">¿QUÉ TE OFRECEMOS?</p>
        <p className="mx-auto max-w-4xl text-2xl">
          Busca la seguridad con los expertos y consigue los mejores beneficios para tus finanzas
          con {APP_NAME_BRAND}
        </p>
      </div>
      <div className="relative border-t-[22px] border-red-500">
        <div className="absolute inset-x-0 -top-20">
          <div className="justify-around space-y-16 mx-auto max-w-6xl sm:flex sm:space-x-4 sm:space-y-0">
            <div className="mx-auto max-w-xs text-center">
              <Offer1 className="mx-auto h-40 w-40" />
              <p className="mx-auto mt-4 max-w-[200px] text-2xl font-bold sm:mt-8">
                INICIA SESIÓN O REGÍSTRATE
              </p>
              <p className="mt-4 text-lg">
                Estamos registrados en la SBS y todas tus operaciones se hacen a través de
                transferencias bancarias.
              </p>
            </div>
            <div className="mx-auto max-w-xs text-center">
              <Offer2 className="mx-auto h-40 w-40" />
              <p className="mx-auto mt-4 max-w-[200px] text-2xl font-bold sm:mt-8">
                REALIZA TU OPERACIÓN
              </p>
              <p className="mt-4 text-lg">
                Estamos registrados en la SBS y todas tus operaciones se hacen a través de
                transferencias bancarias.
              </p>
            </div>
            <div className="mx-auto max-w-xs text-center">
              <Offer3 className="mx-auto h-40 w-40" />
              <p className="mx-auto mt-4 max-w-[200px] text-2xl font-bold sm:mt-8">
                TRANSFIERE Y COMUNICA
              </p>
              <p className="mt-4 text-lg">
                Estamos registrados en la SBS y todas tus operaciones se hacen a través de
                transferencias bancarias.
              </p>
            </div>
          </div>
          {APP_NAME === 'Cambiob2b' && (
            <img src={CCLLogo} className="mx-auto mt-20 w-full sm:h-40 sm:w-auto" alt="" />
          )}

          <LandingFooter />
        </div>
      </div>
    </div>
  );
}
